import { Level } from '@app/logger/level';

export const environment = {
  autoLogin: false,
  envName: 'production',
  logger: {
    level: Level.LOG
  },
  production: true,
  showFormsInDevelopment: false
};
